import { render, staticRenderFns } from "./BatchQuantitiesManager.template.vue?vue&type=template&id=21b8b7b8&scoped=true&"
var script = {}
import style0 from "./BatchQuantitiesManager.template.vue?vue&type=style&index=0&id=21b8b7b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8b7b8",
  null
  
)

export default component.exports